<template>
    <reports-base
        page-size-changeable
        exportable
        reports-name="promoUsage"
        reports-title="Raport/ Użycia promocji"
        component-name="PromoUsage"
        exportable-tooltip="Eksport zawiera maksymalnie 31 dni kalendarzowych"
        @onExport="onExport"
    >
        <div class="c-thead">
            <div class="c-tw w-left">
                <div class="c-td is-1">Detalista</div>
                <div class="c-td is-2">Kasa</div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-3">Promocja</div>
                <div class="c-td is-4 text-center">Data</div>
                <div class="c-td is-5">Liczba użyć</div>
                <div class="c-td is-6">
                    <div
                        v-tooltip="'Prognozowany Zwrot Kosztów'"
                        class="d-flex flex-xl-row flex-column align-items-center justify-content-end"
                    >
                        <span class="typo-label">Zwrot Kosztów</span>
                        <a-icon
                            class="typo-label icon ml-1"
                            icon="Info"
                            style="width: 16px; height: 16px"
                        />
                    </div>
                </div>
            </div>
        </div>
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    components: {
        ReportsBase
    },
    methods: {
        onExport() {
            this.$store.dispatch('fetchPromotionUsageReport')
        }
    }
}
</script>
